<template>
  <el-form-item
    :class="`${!valid ? 'is-error' : ''}`"
    style="margin-top: -4px;"
  >
    <el-select
      v-model="supplier"
      :disabled="disabled"
      filterable
      style="width: 100%;"
      size="small"
      value-key="id"
      @change="onSupplierChange"
    >
      <el-option
        v-for="supp in availableSuppliers"
        :key="supp.id"
        :value="supp"
        :label="`#${supp.id} ${supp.company.name}`"
      >
        #{{ supp.id }} {{ supp.company.name }}
        <span
          style="float: right; color: #8492a6; font-size: 13px; margin-left: 20px;"
          v-if="isProductSelectFromStock"
        >
          <el-tag
            size="mini"
            type="info"
          >
            {{ supp.count || 0 }} {{ packTypeName }} készleten
          </el-tag>
        </span>
      </el-option>
    </el-select>
    <div
      v-if="!valid"
      class="el-form-item__error"
      style="padding-top: 0;"
    >
      Kötelező választani
    </div>
  </el-form-item>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default() {
        return false;
      },
      required: false,
    },
    packTypeName: {
      type: String,
      default() {
        return 'db';
      },
      required: false,
    },
    autoSelectStock: {
      type: Boolean,
      default() {
        return false;
      },
      required: false,
    },
    isProductSelectFromStock: {
      type: Boolean,
      default() {
        return true;
      },
      required: false,
    },
    valid: {
      type: Boolean,
      default() {
        return true;
      },
      required: false,
    },
    defaultSupplier: {
      type: Object,
      default() {
        return null;
      },
      required: false,
    },
    availableSuppliers: {
      type: Array,
      default() {
        return [];
      },
      required: false,
    },
  },
  data() {
    return {
      supplier: null,
    };
  },
  watch: {
    defaultSupplier(supplier) {
      this.supplier = supplier;
      this.onSupplierChange(this.supplier);
    },
    availableSuppliers(suppliers) {
      if (this.autoSelectStock && !this.supplier) {
        let count = 0;
        suppliers.forEach(supp => {
          if (supp.count >= count) {
            this.supplier = JSON.parse(JSON.stringify(supp));
            count = supp.count;
          }
        });
        this.onSupplierChange(this.supplier);
      }
    },
  },
  mounted() {
    this.supplier = this.defaultSupplier;
    this.onSupplierChange(this.supplier);
  },
  methods: {
    onSupplierChange(supplier) {
      this.$emit('change', supplier);
    },
  },
};
</script>
